import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";

export interface BuyFirstNumberPromptProps {
  onBuy: () => void;
}

export const BuyFirstNumberPrompt = ({ onBuy }: BuyFirstNumberPromptProps) => {
  const { t } = useTranslation("onboarding");

  return (
    <div className="flex flex-col gap-4 items-center justify-center">
      <Button variant="outline" onClick={onBuy}>
        {t("Buy a toll-free number")}
      </Button>
      <p className="text-sm text-muted-foreground">
        {t("Get started with texting and calling by purchasing a phone number.")}
      </p>
      <p className="text-xs text-muted-foreground">{t("Powered by Twilio")}</p>
    </div>
  );
};
